// Line total for a quantity, preserving "no price" rather than multiplying by 0.
export const multiplyPrice = (
  price: number | undefined,
  quantity: number | undefined,
): number | undefined =>
  price === undefined ? undefined : price * (quantity || 1);
